import { createFileRoute } from '@tanstack/react-router';

import { ArtistWorkInviteInfoPage } from '@/features/work/pages/artist-work-invite-info-page/ArtistWorkInviteInfoPage';
import { redirectUnauthenticated } from '@/shared/helper/redirectUnauthenticated';

export const Route = createFileRoute('/artist/$id/work-invite/$workInviteId')({
  beforeLoad: ({ context }) => {
    redirectUnauthenticated(context);
  },
  component: ArtistWorkInviteInfoPage
});
